const data = {
  id: 1,
  title: 'Type the correct tense of verb in the bracket.',
  subTitle: 'Chia dạng đúng của động từ trong ngoặc.',
  question: "We can't go out now. It (rain) ___.",
  // answers: 'rains',
  answers: [
    { id: 1, answer: 'rains', isCorrect: true },
  ],
};

export default data;
